/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

export const LOAD_LEAVE_DETAILS = `${url}/LOAD_LEAVE_DETAILS`;
export const LOAD_LEAVE_DETAILS_SUCCESS = `${url}/LOAD_LEAVE_DETAILS_SUCCESS`;
export const LOAD_LEAVE_DETAILS_ERROR = `${url}/LOAD_LEAVE_DETAILS_ERROR`;

export const LOAD_PERMISSION = `${url}/LOAD_PERMISSION`;
export const LOAD_LEAVE_PERMISSION_SUCCESS = `${url}/LOAD_LEAVE_PERMISSION_SUCCESS`;
export const LOAD_LEAVE_PERMISSION_ERROR = `${url}/LOAD_LEAVE_PERMISSION_ERRORS`;

export const LOAD_LOP = `${url}/LOAD_LOP`;
export const LOAD_LOP_SUCCESS = `${url}/LOAD_LOP_SUCCESS`;
export const LOAD_LOP_ERROR = `${url}/LOAD_LOP_ERRORS`;

export const LOAD_DROPDOWN_LEAVE = `${url}/LOAD_DROPDOWN_LEAVE`;
export const LOAD_DROPDOWN_LEAVE_SUCCESS = `${url}/LOAD_DROPDOWN_LEAVE_SUCCESS`;
export const LOAD_DROPDOWN_LEAVE_ERROR = `${url}/LOAD_DROPDOWN_LEAVE_ERROR`;

export const LOAD_SETTING = `${url}/LOAD_SETTING`;
export const LOAD_SETTING_SUCCESS = `${url}/LOAD_SETTING_SUCCESS`;
export const LOAD_SETTING_ERROR = `${url}/LOAD_SETTING_ERRORS`;

const constants = {
  LOAD_LEAVE_DETAILS,
  LOAD_LEAVE_DETAILS_SUCCESS,
  LOAD_LEAVE_DETAILS_ERROR,

  LOAD_PERMISSION,
  LOAD_LEAVE_PERMISSION_SUCCESS,
  LOAD_LEAVE_PERMISSION_ERROR,

  LOAD_LOP,
  LOAD_LOP_SUCCESS,
  LOAD_LOP_ERROR,

  LOAD_DROPDOWN_LEAVE,
  LOAD_DROPDOWN_LEAVE_SUCCESS,
  LOAD_DROPDOWN_LEAVE_ERROR,

  LOAD_RECORDS_VALID_CACHE,
};

export default constants;
